import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	managePlans: {
		defaultMessage: 'View all plans',
		id: 'atlassian-navigation.plans.menu.action-footer.manage-plans',
		description: 'Dropdown item title in the top bar navigation. Item navigates to view all Plans',
	},
	createPlan: {
		defaultMessage: 'Create plan',
		id: 'atlassian-navigation.plans.menu.action-footer.create-plan',
		description: 'Dropdown item title in the top bar navigation. Item navigates to create a plan',
	},
	createDemoPlan: {
		defaultMessage: 'Create demo plan',
		id: 'atlassian-navigation.plans.menu.action-footer.create-demo-plan',
		description:
			'Dropdown item title in the top bar navigation. Item navigates to create a demo plan',
	},
});
